import { InjectionToken } from '@angular/core';

export const webSocketFactoryToken = new InjectionToken<typeof createWebSocket>('webSocketFactory');

export function createWebSocket(url: string | URL): WebSocket {
    // Important note: this does not mean that the socket has finished connecting.
    // You have to add an event handler to ensure that you're connected.
    return new WebSocket(url);
}
